/* ViralCart AI theme — product page behavior: variant selection without a
   page reload, media gallery, sticky ATC sync. The variant picker reads the
   product JSON embedded by sections/main-product.liquid. */
(function () {
  'use strict';

  var strings = (window.vcTheme && window.vcTheme.strings) || {};

  function money(cents) {
    return window.vcCart ? window.vcCart.formatMoney(cents) : '$' + (cents / 100).toFixed(2);
  }

  var VariantPicker = function (root) {
    var dataEl = document.getElementById(root.getAttribute('data-product-json'));
    if (!dataEl) return;
    this.root = root;
    this.product = JSON.parse(dataEl.textContent);
    this.section = root.closest('[data-product-section]') || document;
    root.addEventListener('change', this.onChange.bind(this));
  };

  VariantPicker.prototype.selectedOptions = function () {
    return Array.prototype.map.call(
      this.root.querySelectorAll('fieldset'),
      function (set) {
        var checked = set.querySelector('input:checked');
        return checked ? checked.value : null;
      }
    );
  };

  VariantPicker.prototype.onChange = function () {
    var options = this.selectedOptions();
    var variant = this.product.variants.find(function (v) {
      return v.options.every(function (value, i) { return value === options[i]; });
    });
    this.apply(variant || null);
  };

  VariantPicker.prototype.apply = function (variant) {
    var section = this.section;
    var idInputs = section.querySelectorAll('input[name="id"]');
    var buttons = section.querySelectorAll('[data-add-to-cart]');
    var priceEls = section.querySelectorAll('[data-price]');
    var compareEls = section.querySelectorAll('[data-compare-price]');

    if (!variant) {
      buttons.forEach(function (b) {
        b.disabled = true;
        b.textContent = strings.unavailable || 'Unavailable';
      });
      return;
    }

    idInputs.forEach(function (input) { input.value = variant.id; });
    buttons.forEach(function (b) {
      b.disabled = !variant.available;
      b.textContent = variant.available
        ? strings.addToCart || 'Add to cart'
        : strings.soldOut || 'Sold out';
    });
    priceEls.forEach(function (el) { el.textContent = money(variant.price); });
    compareEls.forEach(function (el) {
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      el.hidden = !onSale;
      if (onSale) el.textContent = money(variant.compare_at_price);
    });

    // Keep the URL shareable for the selected variant.
    if (window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    // Jump the gallery to the variant image when it has one.
    if (variant.featured_media) {
      var thumb = section.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
      if (thumb) thumb.click();
    }
  };

  var Gallery = function (root) {
    this.root = root;
    this.main = root.querySelector('[data-gallery-main]');
    root.addEventListener('click', this.onClick.bind(this));
  };

  Gallery.prototype.onClick = function (e) {
    var thumb = e.target.closest('[data-media-id]');
    if (!thumb || !this.main) return;
    var target = this.root.querySelector(
      '[data-gallery-item][data-media-id="' + thumb.getAttribute('data-media-id') + '"]'
    );
    if (!target) return;
    this.root.querySelectorAll('[data-gallery-item]').forEach(function (item) {
      item.hidden = item !== target;
    });
    this.root.querySelectorAll('[data-media-id]').forEach(function (t) {
      if (t.hasAttribute('data-gallery-item')) return;
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-variant-picker]').forEach(function (el) {
      new VariantPicker(el);
    });
    document.querySelectorAll('[data-media-gallery]').forEach(function (el) {
      new Gallery(el);
    });

    // Record for "recently viewed" sections (kept small, newest first).
    var holder = document.querySelector('[data-product-handle]');
    if (holder) {
      try {
        var handle = holder.getAttribute('data-product-handle');
        var seen = JSON.parse(localStorage.getItem('vc:recent') || '[]').filter(function (h) {
          return h !== handle;
        });
        seen.unshift(handle);
        localStorage.setItem('vc:recent', JSON.stringify(seen.slice(0, 12)));
      } catch (e) {
        /* storage unavailable — non-essential */
      }
    }
  });
})();
